import { FetchProvidersResponse } from 'app/interfaces/api';
import * as Styled from './styled';
import { useActivityProvider } from 'app/hooks';

interface DashboardSelectProps {
  providers?: FetchProvidersResponse;
  handleClick: (id: string) => void;
}

export default function DashboardSelect(props: DashboardSelectProps) {
  const { providerDetails } = useActivityProvider();

  return (
    <Styled.DropdownWrapper>
      <select onChange={e => props.handleClick(e.target.value)} value={providerDetails?.id}>
        {(props.providers ?? []).map((provider, index) => {
          return (
            <option key={index} value={provider?.providerId}>
              {provider?.orgName}
            </option>
          );
        })}
      </select>
    </Styled.DropdownWrapper>
  );
}
